import ax from '../axios'
import {API_URL} from "../index";
import { ID, ILogin } from "../../constants";
import {k12WebEntry, K12_WEB_CALLBACK} from '../../utils/k12TeacherHandoff'

const STAFF_URL = API_URL.EDUCATION_MODULE + '/staff'

const staffLogin = (baseModel: ILogin) => {
    return ax.post(API_URL.USER_MODULE + '/main-user-login/password/web', baseModel)
}
const getStaffLoginInfo = (id: ID, token?: string) => {
    return ax.get(STAFF_URL+'/login-credentials/'+id, token ? {headers: {Authorization: `Bearer ${token}`}} : undefined)
}

/** Start on the registered callback origin so it can validate its own OAuth state. */
const k12AuthAuthorize = async (): Promise<string> => {
    const response = await ax.get<unknown, {url: string}>(API_URL.EDUCATION_MODULE + '/k12/auth/authorize')
    return k12WebEntry(response.url)
}

/** K12: exchange code for permissionToken */
const k12AuthCallback = (code: string) => {
    return ax.get(API_URL.EDUCATION_MODULE + '/k12/auth/callback?code=' + encodeURIComponent(code) + '&redirectUri=' + encodeURIComponent(K12_WEB_CALLBACK))
}

const redeemK12TeacherHandoff = (proof: {ticket: string; verifier: string}) =>
    ax.post(API_URL.EDUCATION_MODULE + '/k12/auth/teacher-handoff/redeem', proof)

/** K12: exchange permissionToken for user session (token, refreshToken, user data) */
const educationTokenLogin = (permissionToken: string) => {
    return ax.post(API_URL.USER_MODULE + '/main-user-login/education-token', { permissionToken })
}

const createStaff = (baseModel: ILogin) => {
    return ax.post(STAFF_URL, baseModel)
}

interface StaffClassroomPayload {
  userId: number;
  classroomId: number;
}

const createStaffClassroom = (payload: StaffClassroomPayload) => {
  return ax.post(API_URL.EDUCATION_MODULE + '/staff-classroom', payload);
}

interface UpdateStaffPayload {
    active: boolean;
    name: string;
    lastName: string;
    organizationId: number;
    schoolIds: number[];
    classroomIds: number[];
    positionId: number;
}

const updateStaff = (staffId: number, payload: UpdateStaffPayload) => {
    return ax.put(`${STAFF_URL}/${staffId}`, payload);
}

export {
    staffLogin,
    getStaffLoginInfo,
    k12AuthAuthorize,
    k12AuthCallback,
    educationTokenLogin,
    redeemK12TeacherHandoff,
    createStaffClassroom,
    updateStaff
}
